<div class="file-upload-container">
  <div
    class="dropzone-container"
    [class.disabled]="maxFiles === 1 && hasFiles"
    [class.disabled]="custom_fileName ? isFileExist : false"
  >
    <!-- Dropzone directive with all configuration -->
    <div
      appDropzone
      [config]="dropzoneConfig"
      [featureName]="featureName"
      [useChunking]="useChunking"
      [chunkSize]="chunkSize"
      (fileAdded)="onFileAdded($event)"
      (uploadSuccess)="onComplete($event)"
      (uploadProgress)="onUploadProgress($event)"
      (uploadSuccess)="onUploadSuccess($event)"
      (uploadError)="onUploadError($event)"
      (uploadDuplicateError)="onDuplicateUploadError($event)"
      (fileRejected)="onFileRejected($event)"
      [fileName]="fileName"
      [fileDescription]="fileDescription"
      [files]="files"
      class=""
    >
      <div class="custom-dropzone">
        <div class="icon-container">
          <img src="assets/icons/upload-cloud.svg" i18n-alt alt="upload-cloud-icon" />
        </div>

        <div class="description">
          <p class="title-text modal-sub-heading" i18n>Select a file or drag and drop it here</p>
          <p class="sub-title-text" i18n>Supports only {{ acceptedFileTypes }} file.</p>
        </div>
        <div class="fallback">
          <!-- Fallback for browsers that don't support drag'n'drop -->
          <input type="file" name="file" [multiple]="maxFiles !== 1" [accept]="acceptedFileTypes" />
        </div>
        <app-buttons
          class="fileinput-button"
          [isDisabled]="true"
          [class.disabled]="true"
          [name]="selectFileBtnText"
          [buttonType]="btnMatStroked"
          [buttonStyle]="btnStyleStroked"
          (click)="browseFiles()"
        ></app-buttons>
      </div>

      <div id="preview-template" style="display: none">
        <div class="dz-preview dz-file-preview">
          <div class="dz-details">
            <div class="dz-thumbnail">
              <img data-dz-thumbnail />
            </div>
          </div>
          <div class="dz-file-details-container">
            <div class="dz-info">
              <div class="dz-file-details">
                <div class="dz-filename-container">
                  <span class="dz-filename" data-dz-name></span>
                  <span class="dz-completed-status" style="display: none"></span>
                </div>
                <span class="dz-file-size" data-dz-size></span>
              </div>
            </div>
            <div class="dz-progress">
              <span class="dz-upload" data-dz-uploadprogress></span>
            </div>
            <div class="dz-error">
              <img data-dz-error />
            </div>
          </div>
        </div>
      </div>
      <!-- Optional custom preview template can go here -->
    </div>
  </div>
  <!-- Optional error display area -->
  <div class="upload-errors" *ngIf="errorMessage">
    <div class="alert alert-danger">
      {{ errorMessage }}
    </div>
  </div>
</div>
